import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { getImageUrl } from '../utils/cdn';
import { getApiUrl } from '../utils/apiUrl';
import './Home.css';

const Home = ({ settings }) => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeaturedProducts();
  }, []);

  const fetchFeaturedProducts = async () => {
    try {
      const response = await axios.get(`${getApiUrl()}/products?featured=true&limit=6`);
      // Ensure products is always an array
      setFeaturedProducts(response.data?.products || []);
    } catch (error) {
      console.error('Failed to fetch featured products:', error);
      // Set empty array on error
      setFeaturedProducts([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{settings?.homepage_title || settings?.site_name || 'NieHairLabel'} - Premium Wigs</title>
        <meta name="description" content={settings?.homepage_description || settings?.site_description || 'Discover our premium collection of wigs'} />
        <meta property="og:title" content={settings?.homepage_title || settings?.site_name} />
        <meta property="og:description" content={settings?.homepage_description || settings?.site_description} />
      </Helmet>

      <div className="home">
        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <div className="hero-content">
              <h1>{settings?.homepage_title || 'Welcome to NieHairLabel'}</h1>
              <p>{settings?.homepage_description || 'Discover our premium collection of wigs'}</p>
              <Link to="/shop" className="btn btn-primary">Shop Now</Link>
            </div>
          </div>
        </section>

        {/* Featured Products */}
        <section className="featured-products">
          <div className="container">
            <h2>Featured Products</h2>
            {loading ? (
              <div className="loading">Loading products...</div>
            ) : featuredProducts && featuredProducts.length > 0 ? (
              <div className="products-grid">
                {featuredProducts.map(product => (
                  <div key={product.id} className="product-card">
                    <Link to={`/shop/${product.slug}`}>
                      <div className="product-image">
                        {product.image_url ? (
                          <img 
                            src={getImageUrl(product.image_url)} 
                            alt={product.name}
                            loading="lazy"
                          />
                        ) : (
                          <div className="placeholder-image">No Image</div>
                        )}
                        {product.stock_status === 'OUT OF STOCK' && (
                          <span className="sold-out-badge">Out of Stock</span>
                        )}
                      </div>
                      <div className="product-info">
                        <h3>{product.name}</h3>
                        <div className="product-price">
                          <span className="price">${product.price}</span>
                          {product.compare_price && (
                            <span className="compare-price">${product.compare_price}</span>
                          )}
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            ) : (
              <p>No featured products available.</p>
            )}
            <div className="text-center" style={{ marginTop: '2rem' }}>
              <Link to="/shop" className="btn btn-outline">View All Products</Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;

